export const SUPPLY_DESTINATION_KINDS = {
  PROJECT: 'project',
  INTERNAL: 'internal',
};

export const SUPPLY_DESTINATION_LABELS = {
  project: 'Proyecto',
  internal: 'Uso interno',
};

export const SUPPLY_DESTINATION_OPTIONS = Object.entries(SUPPLY_DESTINATION_LABELS).map(
  ([value, label]) => ({ value, label })
);

export const SUPPLY_DESTINATION_TEXTS = {
  title: 'Destino de la compra',
  kind: '¿Para qué es la orden?',
  project: 'Proyecto',
  searchProject: 'Buscar por loteo, manzana o casa',
  reason: 'Motivo del uso interno',
  reasonDetail: 'Detalle del motivo',
  technicalDestinations: 'Proyectos / Uso interno de los pedidos técnicos',
  requiredKind: 'Seleccioná Proyecto o Uso interno.',
  requiredProject: 'Seleccioná el Proyecto.',
  requiredReason: 'Seleccioná el motivo del uso interno.',
  requiredReasonDetail: 'Detallá el motivo al seleccionar Otro.',
  reasonTooLong: 'El detalle admite hasta 1000 caracteres.',
  projectLoadError: 'No se pudieron cargar los proyectos.',
  retry: 'Reintentar',
  invalidForm:
    'Completá el destino de la compra, el depósito y los artículos con cantidad válida.',
};
